import { useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';

export const useRealtimeTables = ({
  channelName,
  tables = [],
  onChange,
  enabled = true,
  debounceMs = 250,
  schema = 'public'
}) => {
  const onChangeRef = useRef(onChange);
  const tablesKey = tables.join('|');

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    if (!enabled || !tables.length) {
      return undefined;
    }

    let debounceTimer = null;
    const uniqueName = `${channelName}-${Date.now()}`;
    let channel = supabase.channel(uniqueName);

    const triggerChange = (payload) => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      debounceTimer = setTimeout(() => {
        onChangeRef.current?.(payload);
      }, debounceMs);
    };

    tables.forEach((table) => {
      channel = channel.on(
        'postgres_changes',
        {
          event: '*',
          schema,
          table
        },
        triggerChange
      );
    });

    channel.subscribe((status, err) => {
      if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
        console.error(`[Realtime] ${channelName} subscription issue:`, status, err || 'no error details');
      }
    });

    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      supabase.removeChannel(channel);
    };
  }, [channelName, tablesKey, enabled, debounceMs, schema]);
};
